/* Floodlight · hero football controller (owner: home). Port of prototype 23-ball.js.
   Drag with inertia, tap to kick, hover tilt, keys, off-screen pause, phone idle stop,
   reduced-motion still frame. Drawing: ss-ball-draw.js (SS._ballDraw). */
(function () {
  'use strict';
  if (window.SS_LOADED_ballGeo) return;
  window.SS_LOADED_ballGeo = true;
  var SS = window.SS = window.SS || {};
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var GEO = null;

  function buildGeo() {
    var phi = (1 + Math.sqrt(5)) / 2, V = [], E = [], i, j;
    [-1, 1].forEach(function (a) { [-1, 1].forEach(function (b) { V.push([0, a, b * phi], [a, b * phi, 0], [b * phi, 0, a]); }); });
    for (i = 0; i < 12; i++) for (j = i + 1; j < 12; j++) {
      var d = Math.pow(V[i][0] - V[j][0], 2) + Math.pow(V[i][1] - V[j][1], 2) + Math.pow(V[i][2] - V[j][2], 2);
      if (Math.abs(d - 4) < 0.01) E.push([i, j]);
    }
    var nrm = function (v) { var l = Math.hypot(v[0], v[1], v[2]); return [v[0] / l, v[1] / l, v[2] / l]; };
    var lerp = function (a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t]; };
    var dot = function (a, b) { return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]; };
    var cross = function (a, b) { return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]]; };
    var arc = function (a, b, n) { var out = []; for (var k = 0; k < n; k++) out.push(nrm(lerp(a, b, k / n))); return out; };
    var pents = V.map(function (v, vi) {
      var n = nrm(v);
      var pts = E.filter(function (e) { return e[0] === vi || e[1] === vi; })
        .map(function (e) { return nrm(lerp(V[vi], V[e[0] === vi ? e[1] : e[0]], 1 / 3)); });
      var u0 = pts[0], d0 = dot(u0, n);
      var u = nrm([u0[0] - n[0] * d0, u0[1] - n[1] * d0, u0[2] - n[2] * d0]);
      var w = cross(n, u);
      pts.sort(function (p, q) { return Math.atan2(dot(p, w), dot(p, u)) - Math.atan2(dot(q, w), dot(q, u)); });
      var ring = [];
      pts.forEach(function (p, k) { ring = ring.concat(arc(p, pts[(k + 1) % 5], 5)); });
      return { n: n, ring: ring };
    });
    var seams = E.map(function (e) {
      return arc(nrm(lerp(V[e[0]], V[e[1]], 1 / 3)), nrm(lerp(V[e[0]], V[e[1]], 2 / 3)), 4).concat([nrm(lerp(V[e[0]], V[e[1]], 2 / 3))]);
    });
    var seed = 9;
    var rnd = function () { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; };
    var scuffs = [];
    for (var k = 0; k < 46; k++) {
      var z = rnd() * 2 - 1, an = rnd() * Math.PI * 2, r = Math.sqrt(1 - z * z);
      var p = [r * Math.cos(an), r * Math.sin(an), z];
      var t = nrm(cross(p, [0.3, 1, 0.2]));
      var len = 0.02 + rnd() * 0.07;
      scuffs.push([p, nrm([p[0] + t[0] * len, p[1] + t[1] * len, p[2] + t[2] * len]), rnd() < 0.3]);
    }
    return { pents: pents, seams: seams, scuffs: scuffs };
  }

  function makeGrain() {
    try {
      var g = document.createElement('canvas');
      g.width = 96; g.height = 96;
      var x = g.getContext('2d');
      var d = x.createImageData(96, 96);
      for (var i = 0; i < d.data.length; i += 4) { var v = (Math.random() * 255) | 0; d.data[i] = v; d.data[i + 1] = v; d.data[i + 2] = v; d.data[i + 3] = 46; }
      x.putImageData(d, 0, 0);
      return g;
    } catch (e) { return null; }
  }

  function Ball(cv) {
    var B = this, now = performance.now(), s = Math.sin(0.5), c = Math.cos(0.5);
    B.cv = cv; B.stage = cv.parentElement;
    B.ctx = cv.getContext ? cv.getContext('2d') : null;
    if (!B.ctx) return;
    if (!GEO) GEO = buildGeo();
    B.geo = GEO; B.M = [c, 0, s, 0, 1, 0, -s, 0, c];
    B.wx = 0; B.wy = 0; B.drag = false; B.px = 0; B.py = 0; B.st = 0; B.moved = 0;
    B.visible = true; B.t0 = now; B.last = now; B.act = now; B.tx = 0; B.ty = 0; B.hx = 0; B.hy = 0;
    B.frame = 0; B.raf = 0; B.hop = -1e9; B.flash = -1e9; B.dust = []; B.grain = makeGrain(); B.pat = null;
    B.rot(0.35, 0.3);
    if (B.reduced()) B.t0 -= 6000;

    B.onDown = function (e) {
      B.drag = true; B.px = e.clientX; B.py = e.clientY; B.st = performance.now(); B.moved = 0; B.wx = 0; B.wy = 0; B.act = B.st;
      try { cv.setPointerCapture(e.pointerId); } catch (err) {}
      B.kick();
    };
    B.onMove = function (e) {
      var r = cv.getBoundingClientRect();
      if (B.drag) {
        var dx = e.clientX - B.px, dy = e.clientY - B.py;
        B.px = e.clientX; B.py = e.clientY;
        B.moved += Math.abs(dx) + Math.abs(dy);
        B.act = performance.now();
        if (B.moved > 8) B.mark();
        var k = 3.2 / Math.max(200, r.width);
        B.rot(dx * k, dy * k);
        B.wy = dx * k * 60; B.wx = dy * k * 60;
        if (B.reduced()) B.drawNow();
      } else if (e.pointerType === 'mouse' && r.width) {
        B.hx = (e.clientX - r.left) / r.width - 0.5; B.hy = (e.clientY - r.top) / r.height - 0.5;
        B.kick();
      }
    };
    B.onUp = function (e) {
      if (!B.drag) return;
      B.drag = false;
      var t = performance.now();
      if (B.moved < 8 && t - B.st < 450) B.kickBall(e, t);
      B.act = t;
      B.kick();
    };
    B.onCancel = function () { B.drag = false; };
    B.onLeave = function () { B.hx = 0; B.hy = 0; };
    B.onKey = function (e) {
      var key = e.key, t = performance.now();
      var spin = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[key];
      if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
        e.preventDefault();
        B.kickBall(null, t);
      } else if (spin) {
        e.preventDefault();
        B.mark();
        B.wy += spin[0] * 2.6; B.wx += spin[1] * 2.6;
        if (B.reduced()) { B.rot(spin[0] * 0.3, spin[1] * 0.3); B.drawNow(); }
      } else return;
      B.act = t;
      B.kick();
    };
    B.onVis = function () { B.kick(); };
    B.onResize = function () { B.act = performance.now(); B.kick(); if (B.reduced()) B.drawNow(); };
    B.onMotion = function () { B.t0 = performance.now() - (B.reduced() ? 6000 : 3000); B.kick(); B.drawNow(); };

    cv.addEventListener('keydown', B.onKey);
    cv.addEventListener('pointerdown', B.onDown);
    cv.addEventListener('pointermove', B.onMove);
    cv.addEventListener('pointerup', B.onUp);
    cv.addEventListener('pointercancel', B.onCancel);
    cv.addEventListener('pointerleave', B.onLeave);
    document.addEventListener('visibilitychange', B.onVis);
    window.addEventListener('resize', B.onResize, { passive: true });
    if (mq) { if (mq.addEventListener) mq.addEventListener('change', B.onMotion); else if (mq.addListener) mq.addListener(B.onMotion); }
    if ('IntersectionObserver' in window) {
      B.io = new IntersectionObserver(function (en) { B.visible = en[en.length - 1].isIntersecting; B.kick(); });
      B.io.observe(cv);
    }
    cv.__ssBall = B;
    B.kick();
    if (B.reduced()) B.drawNow();
  }

  Ball.prototype.reduced = function () { return !!(mq && mq.matches); };
  Ball.prototype.mark = function () { if (this.stage) this.stage.classList.add('dragged'); };
  Ball.prototype.draw = function (now) { return SS._ballDraw ? SS._ballDraw(this, now) : true; };
  Ball.prototype.drawNow = function () { if (this.ctx) this.draw(performance.now()); };

  Ball.prototype.kickBall = function (e, now) {
    var B = this, r = B.cv.getBoundingClientRect();
    B.mark();
    var side = e && r.width ? (e.clientX - r.left) / r.width - 0.5 : 0;
    if (B.reduced()) { B.rot(side < 0 ? 0.6 : -0.6, -0.3); B.drawNow(); return; }
    B.hop = now; B.flash = now;
    B.wy += (side < 0 ? 1 : -1) * (7 + Math.random() * 3);
    B.wx -= 3 + Math.random() * 2;
    var w = B.cv.clientWidth, h = B.cv.clientHeight, R = Math.min(w, h) * 0.34, gy = h * 0.46 + R * 1.04;
    for (var i = 0; i < 38; i++) {
      var a = 0.15 + Math.random() * (Math.PI - 0.3), sp = 50 + Math.random() * 190;
      B.dust.push({ x: w / 2 + (Math.random() - 0.5) * R * 1.1, y: gy - 2, vx: Math.cos(a) * sp, vy: -Math.sin(a) * sp * 0.9, life: 0, max: 0.6 + Math.random() * 0.8, s: 0.8 + Math.random() * 2.2, g: Math.random() < 0.4 });
    }
  };

  /* start the loop if it is not running (the name follows the prototype's ballKick) */
  Ball.prototype.kick = function () {
    var B = this;
    if (!B.ctx || B.dead || B.raf) return;
    if (!B.visible || document.hidden) return;
    if (B.reduced() && !B.drag) { B.drawNow(); return; }
    B.last = performance.now();
    var tick = function (now) {
      B.raf = 0;
      if (B.dead) return;
      /* phones: after the intro bounce, a slow free spin is drawn at 30 fps (half the main-thread work) */
      var cap = (window.innerWidth || 1440) < 768 && !B.drag && !B.dust.length && now - B.t0 > 3400 && now - B.hop > 1700 && now - B.act > 600;
      var more = true;
      if (cap && now - (B.drawn || 0) < 30) { /* skip this frame */ }
      else { B.drawn = now; more = B.draw(now); }
      if (more && B.visible && !document.hidden && (!B.reduced() || B.drag)) B.raf = requestAnimationFrame(tick);
    };
    B.raf = requestAnimationFrame(tick);
  };

  Ball.prototype.rot = function (ay, ax) {
    var M = this.M;
    var cy = Math.cos(ay), sy = Math.sin(ay), cx = Math.cos(ax), sx = Math.sin(ax);
    for (var col = 0; col < 3; col++) {
      var x = M[col], y = M[3 + col], z = M[6 + col];
      var x1 = cy * x + sy * z, z1 = -sy * x + cy * z;
      var y2 = cx * y - sx * z1, z2 = sx * y + cx * z1;
      M[col] = x1; M[3 + col] = y2; M[6 + col] = z2;
    }
    if (++this.frame % 90 === 0) {
      var a = [M[0], M[3], M[6]], b = [M[1], M[4], M[7]];
      var la = Math.hypot(a[0], a[1], a[2]); a[0] /= la; a[1] /= la; a[2] /= la;
      var d = a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
      b[0] -= d * a[0]; b[1] -= d * a[1]; b[2] -= d * a[2];
      var lb = Math.hypot(b[0], b[1], b[2]); b[0] /= lb; b[1] /= lb; b[2] /= lb;
      M[0] = a[0]; M[3] = a[1]; M[6] = a[2]; M[1] = b[0]; M[4] = b[1]; M[7] = b[2];
      M[2] = a[1] * b[2] - a[2] * b[1]; M[5] = a[2] * b[0] - a[0] * b[2]; M[8] = a[0] * b[1] - a[1] * b[0];
    }
  };

  Ball.prototype.destroy = function () {
    var B = this, cv = B.cv;
    B.dead = true;
    cancelAnimationFrame(B.raf); B.raf = 0;
    if (B.io) B.io.disconnect();
    cv.removeEventListener('keydown', B.onKey);
    cv.removeEventListener('pointerdown', B.onDown);
    cv.removeEventListener('pointermove', B.onMove);
    cv.removeEventListener('pointerup', B.onUp);
    cv.removeEventListener('pointercancel', B.onCancel);
    cv.removeEventListener('pointerleave', B.onLeave);
    document.removeEventListener('visibilitychange', B.onVis);
    window.removeEventListener('resize', B.onResize);
    if (mq) { if (mq.removeEventListener) mq.removeEventListener('change', B.onMotion); else if (mq.removeListener) mq.removeListener(B.onMotion); }
    cv.__ssBall = null;
  };

  SS.Ball = Ball;

  function initHero(sec) {
    var cv = sec.querySelector('canvas[data-ball]');
    if (!cv) return;
    if (cv.__ssBall) return function () { if (cv.__ssBall) cv.__ssBall.destroy(); };
    var B = new Ball(cv);
    if (!B.ctx) {
      var fb = sec.querySelector('[data-ball-fallback]');
      if (fb) fb.hidden = false;
      cv.hidden = true;
      var hint = sec.querySelector('.ball-hint');
      if (hint) hint.hidden = true;
      return;
    }
    return function () { B.destroy(); };
  }

  function ready(type, init) {
    if (typeof SS.sectionReady === 'function') { SS.sectionReady(type, init); return; }
    var sel = '[data-section-type="' + type + '"]';
    var run = function (root) {
      var els = root.matches && root.matches(sel) ? [root] : root.querySelectorAll(sel);
      Array.prototype.forEach.call(els, function (el) { if (!el.__ssDestroy) el.__ssDestroy = init(el) || true; });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
    else run(document);
    document.addEventListener('shopify:section:load', function (e) { run(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var els = e.target.querySelectorAll(sel);
      Array.prototype.forEach.call(els, function (el) { if (typeof el.__ssDestroy === 'function') el.__ssDestroy(); el.__ssDestroy = null; });
    });
  }

  ready('home-hero', initHero);
})();
